module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "browse-item"
  }, [_c('section', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.details,
      "profile-type": "developer",
      "size": "large",
      "show-xp-info": true
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "overview"
  }, [_c('span', {
    staticClass: "name"
  }, [_c('router-link', {
    attrs: {
      "to": '/Developer/' + _vm.details.stringUrl
    }
  }, [_c('i', {
    class: [{
      'fas fa-user': true,
      'online': _vm.developerIsOnline
    }]
  }), _vm._v(" " + _vm._s(_vm.details.alias))])], 1), _vm._v(" "), _c('span', {
    staticClass: "last-online"
  }, [_vm._v("Last Online: " + _vm._s(_vm._f("formatDate")(_vm.details.lastOnline)))]), _vm._v(" "), _c('span', {
    staticClass: "last-online"
  }, [_vm._v("Registered: " + _vm._s(_vm._f("formatDate")(_vm.details.registrationDate)))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.details.location))]), _vm._v(" "), (_vm.isLoggedIn) ? _c('span', {
    staticClass: "proximity"
  }, [_vm._v(_vm._s(_vm.details.proximity) + " miles away")]) : _vm._e(), _vm._v(" "), (_vm.details.lookingForGame) ? _c('span', {
    staticClass: "wants-to-collab"
  }, [_vm._v("Wants to Join a Game Project")]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "about"
  }, [_c('span', {
    staticClass: "text-roles"
  }, [_vm._v(_vm._s(_vm.details.role))]), _vm._v(" "), _c('ul', {
    staticClass: "official-roles"
  }, [(_vm.details.isDesigner) ? _c('li', [_vm._v("Designer")]) : _vm._e(), _vm._v(" "), (_vm.details.isArtist) ? _c('li', [_vm._v("Artist")]) : _vm._e(), _vm._v(" "), (_vm.details.isProgrammer) ? _c('li', [_vm._v("Programmer")]) : _vm._e(), _vm._v(" "), (_vm.details.isWriter) ? _c('li', [_vm._v("Writer")]) : _vm._e(), _vm._v(" "), (_vm.details.isMusician) ? _c('li', [_vm._v("Musician")]) : _vm._e(), _vm._v(" "), (_vm.details.isSfxArtist) ? _c('li', [_vm._v("SFX Artist")]) : _vm._e(), _vm._v(" "), (_vm.details.isTester) ? _c('li', [_vm._v("Tester")]) : _vm._e(), _vm._v(" "), (_vm.details.isProducer) ? _c('li', [_vm._v("Producer")]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "skills"
  }, _vm._l((_vm.details.skills), function(skill) {
    return (_vm.skillList[skill]) ? _c('router-link', {
      staticClass: "role-or-skill-item",
      attrs: {
        "to": '/Browse/Developers?seekingSkill=' + _vm.skillList[skill].id
      }
    }, [_vm._v("\n                " + _vm._s(_vm.skillList[skill].skill) + "\n            ")]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8165691c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Browse/BrowsePageDeveloperItem.vue
// module id = 896
// module chunks = 2